import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Cocoa() {
  return (
    <PredictionPage
      title="Cocoa"
      content="This is the Cocoa AI Trading Predictions page."
      canonical="/commodities/cocoa-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="COCOA"
    />
  );
}

export default Cocoa;
